import { Component } from 'angular-ts-decorators';

import { About } from '@shared/app/scripts/services/about';
import { DateSource } from '@shared/app/scripts/services/date-source';
import { PrintQueue } from '@core/app/scripts/services/print-queue';
import { Version } from '@shared/app/scripts/services/version';

/**
 * Component that shows the `about` information
 */
@Component({
  selector: 'about',
  template: require('./about.html').default,
})
export class AboutComponent {
  currentVersion: any;
  spynlPromise: ng.IPromise<any>;
  spynlVersion: string;
  currentDate: Date;
  printQueueVersion: string;

  constructor(
    private about: About,
    private dateSource: DateSource,
    private printQueue: PrintQueue,
    private version: Version,
  ) {
    'ngInject';
  }

  ngOnInit() {
    this.currentVersion = this.version;

    this.currentDate = this.dateSource.now();

    this.spynlPromise = this.about.get().then(({ version }) => {
      this.spynlVersion = version;
    });

    this.printQueue.ping().then((response) => {
      this.printQueueVersion = response.version;
    });
  }
}
